import React, { FC, useState } from 'react';
import { TemplateReviewTakeoverContext } from './TemplateReviewTakeoverContext';

export const TemplateReviewTakeoverContextProvider: FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [isTemplateReviewTakeoverOpen, setIsTemplateReviewTakeoverOpen] = useState(false);
  return (
    <TemplateReviewTakeoverContext.Provider
      value={{ isTemplateReviewTakeoverOpen, setIsTemplateReviewTakeoverOpen }}
    >
      {children}
    </TemplateReviewTakeoverContext.Provider>
  );
};
